import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../styles/site.css";
import "../styles/chat.css";
import ChatWidget from "../components/ChatWidget";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Check = ({ stroke = "#d4b96a", size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
);

const Arrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

const services = [
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18" /><path d="M7 14l4-4 3 3 5-6" /></svg>),
    title: "Financial Reporting & Analysis",
    desc: "Accurate, timely financial information that tells you exactly how your business is performing.",
    items: ["Preparation of financial statements", "Monthly & year-end financial reporting", "Financial analysis & business performance review", "Budgeting & cash flow visibility"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" /></svg>),
    title: "Accounts Payable",
    desc: "Your bills organized, verified, and paid on time — with vendor relationships protected.",
    items: ["Accounts payable management", "Vendor & supplier payment management", "Invoice organization & recording", "Payment scheduling & expense control"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>),
    title: "Accounts Receivable & Collections",
    desc: "Money you've earned, actually collected — with aging tracked and follow-up handled.",
    items: ["Accounts receivable management", "Collections management & follow-up", "Tracking of incoming payments", "Receivable aging reduction strategies"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" /></svg>),
    title: "Invoicing & Billing",
    desc: "Professional, accurate customer invoicing that keeps revenue flowing without gaps or errors.",
    items: ["Customer invoicing & billing", "Billing accuracy & contract-rate verification", "Billing process automation (incl. EDI)", "Invoice dispute resolution support"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>),
    title: "Payroll Processing",
    desc: "Employees paid accurately and on schedule — every single pay period, without surprises.",
    items: ["Payroll processing & administration", "Payroll system consolidation & cleanup", "Payroll accuracy & error reduction", "Employee payroll recordkeeping"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>),
    title: "Accounting Process Optimization",
    desc: "Inefficient workflows redesigned so your accounting takes less time and produces better information.",
    items: ["Accounting process review & redesign", "Financial workflow improvement", "Automation & digital transformation", "Internal controls & accountability"] },
  { icon: (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>),
    title: "Bookkeeping & Financial Organization",
    desc: "Clean, current, well-organized books — the foundation every healthy business runs on.",
    items: ["Bookkeeping support & catch-up", "Organizing invoices & financial documents", "General ledger & reconciliations", "General accounting support"] }
];

const helpItems = [
  { n: "01", t: "Know your numbers", d: "Clear financial statements and business performance analysis give you the information you need to make confident decisions — not guesses." },
  { n: "02", t: "Improve your cash flow", d: "When receivables are collected faster, payment terms are negotiated well, and cash is tracked closely, your business breathes easier." },
  { n: "03", t: "Stay organized financially", d: "Invoices recorded, documents filed, books reconciled. When everything is where it should be, tax time and audits stop being scary." },
  { n: "04", t: "Pay and get paid on time", d: "Vendors paid on schedule protects your reputation and terms. Customers invoiced promptly with disciplined follow-up protects your revenue." },
  { n: "05", t: "Run payroll with confidence", d: "Your team gets paid accurately, every time. I've reduced payroll errors by up to 70% by fixing the processes behind the paychecks." },
  { n: "06", t: "Save time and reduce workload", d: "Streamlined accounting processes mean fewer hours lost to administrative work — for you and your staff — and fewer costly mistakes to fix." }
];

const whyItems = [
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /></svg>), t: "Attention to Detail", d: "Every entry verified, every reconciliation balanced. Small errors become big problems — I catch them first." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>), t: "Reliability", d: "Deadlines met, payroll on time, reports delivered when promised. You can build on work you can count on." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>), t: "Financial Accuracy", d: "Books you can trust and statements that hold up to scrutiny — from lenders, auditors, or buyers." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>), t: "Organization", d: "Structured systems for documents, invoices, and records — so nothing gets lost and everything is findable." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>), t: "Confidentiality", d: "Your financial information is handled with complete discretion and professional integrity, always." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.4 1 2.3h6c0-.9.4-1.8 1-2.3A7 7 0 0 0 12 2z" /></svg>), t: "Analytical Thinking", d: "An engineer's mindset applied to finance: I look past the numbers to understand what's driving them." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 6l-9.5 9.5-5-5L1 18" /><path d="M17 6h6v6" /></svg>), t: "Process Improvement", d: "I don't just maintain your accounting — I make it better, faster, and less expensive to run." },
  { icon: (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>), t: "Proactive Communication", d: "You'll never wonder where things stand. I flag issues early and keep you informed in plain language." }
];

const timeline = [
  { date: "2023 – Present", org: "LMC Partners / Cutters Edge Total Landscape Solutions", role: "Financial Controller — Boca Raton, FL", desc: "Leading finance and accounting through a multi-business acquisition and merger: standardizing processes, reporting, controls, and systems across a growing organization." },
  { date: "2020 – 2023", org: "Terra Tech Distributors / Baker Landscape Corp.", role: "Controller — Delray Beach, FL", desc: "Directed accounting, budgeting, HR, and payroll for two related companies. Consolidated payroll systems (90% fewer discrepancies), optimized AP/AR workflows to ~95% transaction accuracy, and replaced paper processes with digital workflows that cut labor hours by 45%." },
  { date: "2014 – 2019", org: "Boca Raton Preparatory School", role: "Director of Finance and Administration — Boca Raton, FL", desc: "Ran finance, budgeting, payroll, and operations for a private PK–12 school. Strengthened billing controls for a 45% improvement in collections and partnered with leadership on growth that drove 45% year-over-year revenue gains." },
  { date: "2009 – 2012", org: "United Packaging Corporation", role: "Controller — Miami, FL / San Juan, PR", desc: "Directed multi-location accounting, treasury, and financial operations. Restructured AP and renegotiated vendor terms to reduce expenses by 45%, and strengthened internal controls for a 55% gain in process efficiency." },
  { date: "2006 – 2009", org: "Iberia Food Corporation", role: "Controller — Miami, FL", desc: "Led accounting for multi-location food distribution — GL, billing, AP/AR, collections, and payroll. Implemented EDI billing for major accounts (75% less billing time), improved cash flow 45%, and cut receivable aging from 60 to 40 days." },
  { date: "2001 – 2006", org: "Perishables Group International", role: "Finance & Accounting Manager — Atlanta, GA", desc: "Managed accounting, general ledger, and bookkeeping for a cargo-handling joint venture. Automated payroll to cut processing errors by 70% and costs by 20%." },
  { date: "Earlier Career", org: "Banking & Treasury Leadership — Colombia", role: "Bank Branch Director · International Operations Director · Treasury Manager", desc: "Foundational leadership experience in banking and corporate treasury, building deep expertise in cash management, banking relationships, and financial controls." }
];

export default function RadiSite() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", services: "", message: "" });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const revealRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setStatus({ type: "err", msg: "Please fill in name, email, and message." });
      return;
    }
    try {
      await axios.post(`${API}/leads`, form);
      setStatus({ type: "ok", msg: "Thank you! Your message has been received. Ivette will get back to you within one business day." });
      setForm({ name: "", company: "", email: "", phone: "", services: "", message: "" });
    } catch (err) {
      setStatus({ type: "err", msg: "Something went wrong. Please email iradimorad@gmail.com directly." });
    }
  };

  return (
    <div className="site-root" ref={revealRef}>
      {/* SEO: hidden semantic content for crawlers */}
      <div style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", clip: "rect(0 0 0 0)", whiteSpace: "nowrap" }} aria-hidden="true">
        <h1>Radi Financial LLC — Small Business Accounting, Bookkeeping, Payroll & Financial Operations in Boca Raton, Florida</h1>
        <p>Radi Financial LLC provides professional accounting services, bookkeeping, payroll processing, accounts payable and accounts receivable management, invoicing, collections, financial reporting, budgeting, cash flow analysis, and accounting process optimization for small and mid-size businesses. Bilingual English and Spanish. Servicios de contabilidad bilingüe en Boca Raton, Florida. Outsourced controller and fractional finance leadership with 25+ years of experience across QuickBooks, NetSuite, Acumatica, Sage 50, and MAS 200.</p>
      </div>

      {/* NAV */}
      <nav className={`nav ${scrolled ? "scrolled" : ""} ${open ? "open" : ""}`}>
        <div className="container nav-inner">
          <a href="#top" className="brand" onClick={closeMenu}>
            <img
              src="/brand/radi-financial-logo.png"
              alt="Radi Financial LLC"
              className="brand-logo"
            />
          </a>
          <ul className="nav-links">
            <li><a href="#about" onClick={closeMenu}>About</a></li>
            <li><a href="#services" onClick={closeMenu}>Services</a></li>
            <li><a href="#how-i-help" onClick={closeMenu}>How I Help</a></li>
            <li><a href="#experience" onClick={closeMenu}>Experience</a></li>
            <li><a href="#contact" className="nav-cta" onClick={closeMenu}>Schedule a Consultation</a></li>
          </ul>
          <button className="nav-toggle" aria-label="Toggle menu" onClick={() => setOpen((v) => !v)}>
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* HERO */}
      <header className="hero" id="top">
        <svg className="hero-grid-bg" width="100%" height="100%" aria-hidden="true">
          <defs>
            <pattern id="grid" width="46" height="46" patternUnits="userSpaceOnUse">
              <path d="M 46 0 L 0 0 0 46" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
            </pattern>
            <linearGradient id="fadeg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="white" stopOpacity="1" />
              <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <mask id="gridmask"><rect width="100%" height="100%" fill="url(#fadeg)" /></mask>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" mask="url(#gridmask)" />
        </svg>
        <div className="container">
          <div className="hero-inner">
            <div>
              <div className="hero-badge reveal"><span className="dot" />Radi Financial LLC · Boca Raton, FL</div>
              <h1 className="reveal reveal-d1">Clear numbers. Organized finances. <em>A business that runs smoother.</em></h1>
              <p className="hero-sub reveal reveal-d2">I help small and medium-sized businesses take control of their accounting and financial operations — from financial reporting and bookkeeping to accounts payable, receivables, collections, and payroll — so you always know where your money is and where your business stands.</p>
              <div className="hero-actions reveal reveal-d3">
                <a href="#contact" className="btn btn-gold">Schedule a Consultation <Arrow /></a>
                <a href="#services" className="btn btn-ghost">Explore Services</a>
              </div>
            </div>
            <div className="hero-visual reveal reveal-d2">
              <div className="hero-card" aria-hidden="true">
                <div className="hero-card-head">
                  <div><strong>Financial Operations Snapshot</strong>Results from 25+ years in the field</div>
                  <span className="hero-chip">Proven</span>
                </div>
                <svg viewBox="0 0 380 130" width="100%" style={{ marginTop: 10 }}>
                  <defs>
                    <linearGradient id="areafill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0" stopColor="#d4b96a" stopOpacity=".35" />
                      <stop offset="1" stopColor="#d4b96a" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <polyline points="0,108 55,96 110,100 165,74 220,80 275,52 330,40 380,18" fill="none" stroke="#d4b96a" strokeWidth="2.5" strokeLinecap="round" />
                  <polygon points="0,108 55,96 110,100 165,74 220,80 275,52 330,40 380,18 380,130 0,130" fill="url(#areafill)" />
                  <circle cx="275" cy="52" r="4" fill="#d4b96a" />
                  <circle cx="380" cy="18" r="4" fill="#fff" />
                </svg>
                <div className="hero-metrics">
                  <div className="hero-metric"><b>45%</b><span>expense reduction via AP restructuring</span></div>
                  <div className="hero-metric"><b>70%</b><span>fewer payroll errors after process redesign</span></div>
                  <div className="hero-metric"><b>75%</b><span>less billing time through automation</span></div>
                  <div className="hero-metric"><b>45%</b><span>improvement in collections success</span></div>
                </div>
              </div>
            </div>
          </div>

          <div className="stats-band reveal">
            <div className="stat"><b>25<em>+</em></b><span>years of accounting &amp; financial leadership</span></div>
            <div className="stat"><b>8<em>+</em></b><span>industries served, from distribution to education</span></div>
            <div className="stat"><b>2</b><span>languages — full service in English &amp; Spanish</span></div>
            <div className="stat"><b>100<em>%</em></b><span>confidential, detail-driven, deadline-reliable</span></div>
          </div>
        </div>
      </header>

      {/* ABOUT */}
      <section id="about">
        <div className="container">
          <div className="about-grid">
            <div className="about-visual reveal">
              <div className="about-portrait">
                <div className="monogram">IR</div>
                <h3>Ivette Radi-Morad</h3>
                <span className="role">Accounting &amp; Financial Operations Specialist</span>
                <ul>
                  <li><Check />25+ years in accounting, controllership &amp; FP&amp;A</li>
                  <li><Check />Executive MBA in Financial Management</li>
                  <li><Check />NetSuite, QuickBooks, Acumatica, Sage &amp; more</li>
                  <li><Check />Bilingual: English &amp; Spanish</li>
                  <li><Check />Based in Boca Raton, FL — serving clients everywhere</li>
                </ul>
              </div>
            </div>
            <div className="about-copy">
              <span className="eyebrow reveal">About Me</span>
              <h2 className="section-title reveal">The financial partner growing businesses <br />wish they'd hired sooner</h2>
              <p className="lead-p reveal">For more than 25 years, I've done one thing for the businesses I work with: turned financial chaos into clarity.</p>
              <p className="reveal">I've served as Financial Controller and Director of Finance for companies across distribution, landscaping, food import, packaging, and private education — businesses just like yours, with real invoices piling up, vendors to pay, customers to collect from, and owners who need to know their numbers to make good decisions. I've managed everything from day-to-day bookkeeping and payroll to full financial statement preparation, budgeting, and cash flow strategy.</p>
              <p className="reveal">What sets my work apart is that I don't just record the numbers — I improve the systems behind them. I've consolidated payroll operations to cut errors by 70%, restructured accounts payable to reduce expenses by 45%, moved companies from paper chaos to streamlined digital workflows, and rebuilt collections processes that got cash in the door 45% more successfully. When your accounting processes work, everything else gets easier.</p>
              <p className="reveal">I hold an Executive MBA in Financial Management from Maastricht School of Management and a B.S. in Industrial Engineering with a minor in Accounting — a combination that means I think about your finances the way an engineer thinks about systems: with precision, structure, and an eye for what can work better.</p>
              <div className="credentials">
                <div className="credential reveal">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>
                  <div><b>Executive MBA, Financial Management</b><span>Maastricht School of Management, Netherlands — Merit Scholarship</span></div>
                </div>
                <div className="credential reveal reveal-d1">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
                  <div><b>B.S. Industrial Engineering</b><span>Minor in Accounting — Universidad del Norte</span></div>
                </div>
                <div className="credential reveal reveal-d2">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
                  <div><b>Controller-Level Experience</b><span>Financial Controller &amp; Director of Finance roles since 2001</span></div>
                </div>
                <div className="credential reveal reveal-d3">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z" /></svg>
                  <div><b>Systems Expertise</b><span>NetSuite · Acumatica · QuickBooks · Sage 50 · MAS 200 · EDI</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="services">
        <div className="container">
          <div className="center">
            <span className="eyebrow reveal">Services</span>
            <h2 className="section-title reveal">Complete accounting services for your business</h2>
            <p className="section-lead reveal">From daily bookkeeping to financial reporting and process optimization — everything your business needs to stay organized, compliant, and in control of its finances.</p>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <div key={i} className={`service-card reveal ${i % 3 === 1 ? "reveal-d1" : i % 3 === 2 ? "reveal-d2" : ""}`}>
                <div className="service-icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <ul>{s.items.map((it, j) => <li key={j}>{it}</li>)}</ul>
              </div>
            ))}
            <div className="service-card reveal reveal-d2" style={{ background: "linear-gradient(150deg,var(--navy),var(--navy-3))", borderColor: "var(--navy)" }}>
              <div className="service-icon" style={{ background: "rgba(212,185,106,.18)" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d4b96a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 12h8M12 8v8" /><circle cx="12" cy="12" r="10" /></svg>
              </div>
              <h3 style={{ color: "#fff" }}>Not sure what you need?</h3>
              <p style={{ color: "rgba(255,255,255,.75)" }}>Every business is different. Let's talk through where your finances stand today and build a plan that fits.</p>
              <a href="#contact" className="btn btn-gold" style={{ marginTop: "auto", justifyContent: "center" }}>Let's Talk About Your Business</a>
            </div>
          </div>
        </div>
      </section>

      {/* HOW I HELP */}
      <section id="how-i-help" className="help">
        <div className="container">
          <div className="center">
            <span className="eyebrow reveal" style={{ color: "var(--gold-soft)" }}>How I Help Your Business</span>
            <h2 className="section-title reveal">More than accounting tasks — real business results</h2>
            <p className="section-lead reveal" style={{ margin: "0 auto" }}>Good accounting isn't about data entry. It's about what organized, accurate financial operations make possible for your business.</p>
          </div>
          <div className="help-grid">
            {helpItems.map((h, i) => (
              <div key={i} className={`help-card reveal ${i % 3 === 1 ? "reveal-d1" : i % 3 === 2 ? "reveal-d2" : ""}`}>
                <span className="help-num">{h.n}</span>
                <h3>{h.t}</h3>
                <p>{h.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY */}
      <section id="why">
        <div className="container">
          <div className="center">
            <span className="eyebrow reveal">Why Work With Me</span>
            <h2 className="section-title reveal">The qualities behind the results</h2>
            <p className="section-lead reveal" style={{ margin: "0 auto" }}>Your finances deserve someone who treats them with the same care you do.</p>
          </div>
          <div className="why-grid">
            {whyItems.map((w, i) => (
              <div key={i} className={`why-item reveal ${i % 4 === 1 ? "reveal-d1" : i % 4 === 2 ? "reveal-d2" : i % 4 === 3 ? "reveal-d3" : ""}`}>
                <div className="why-icon">{w.icon}</div>
                <b>{w.t}</b>
                <p>{w.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EXPERIENCE */}
      <section id="experience" className="experience">
        <div className="container">
          <span className="eyebrow reveal">My Experience</span>
          <h2 className="section-title reveal">A career built inside real businesses</h2>
          <p className="section-lead reveal">I've led accounting and financial operations from the inside — as Controller and Finance Director — so I understand what businesses actually need, not just what textbooks say.</p>
          <div className="timeline">
            {timeline.map((t, i) => (
              <div key={i} className="tl-item reveal">
                <span className="tl-date">{t.date}</span>
                <h3>{t.org}</h3>
                <span className="tl-role">{t.role}</span>
                <p>{t.desc}</p>
              </div>
            ))}
          </div>
          <div className="edu-band reveal">
            <div className="edu">
              <span className="edu-tag">Education</span>
              <b>Executive MBA, Financial Management</b>
              <span>Maastricht School of Management — Merit Scholarship recipient</span>
            </div>
            <div className="edu">
              <span className="edu-tag">Education</span>
              <b>B.S. Industrial Engineering &amp; Business Management</b>
              <span>Minor in Accounting — Universidad del Norte</span>
            </div>
            <div className="edu">
              <span className="edu-tag">Professional</span>
              <b>Continuing Development</b>
              <span>CTP Candidate (FIU) · Florida Notary Commission · National Business Officers Association</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="container cta-inner">
          <span className="eyebrow reveal" style={{ color: "var(--gold-soft)" }}>Ready When You Are</span>
          <h2 className="reveal">Your business deserves finances that <em>work as hard as you do</em></h2>
          <p className="reveal">Whether you need ongoing accounting support, help catching up your books, or someone to untangle a process that's costing you time and money — the first conversation is free, and there's no obligation.</p>
          <div className="hero-actions reveal" style={{ justifyContent: "center" }}>
            <a href="#contact" className="btn btn-gold">Schedule a Free Consultation <Arrow /></a>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact">
        <div className="container">
          <div className="center">
            <span className="eyebrow reveal">Contact</span>
            <h2 className="section-title reveal">Let's talk about your business</h2>
            <p className="section-lead reveal" style={{ margin: "0 auto" }}>Tell me a little about your company and what you need help with. I'll get back to you within one business day.</p>
          </div>
          <div className="contact-grid">
            <div className="contact-info reveal">
              <h3>Get in touch directly</h3>
              <p>Prefer email or LinkedIn? Reach out whichever way is easiest for you.</p>
              <div className="contact-line">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><path d="M22 6l-10 7L2 6" /></svg>
                <div><b>Email</b><a href="mailto:iradimorad@gmail.com">iradimorad@gmail.com</a></div>
              </div>
              <div className="contact-line">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>
                <div><b>LinkedIn</b><a href="https://linkedin.com/in/ivetteradi" target="_blank" rel="noopener noreferrer">linkedin.com/in/ivetteradi</a></div>
              </div>
              <div className="contact-line">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b8963e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                <div><b>Location</b><span>Boca Raton, Florida — serving clients locally and remotely</span></div>
              </div>
              <div className="contact-note">
                <b>Se habla español.</b> Full accounting and financial services available in English and Spanish.
              </div>
            </div>
            <div className="form-card reveal reveal-d1">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="field">
                    <label htmlFor="f-name">Name *</label>
                    <input type="text" id="f-name" required placeholder="Your full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                  </div>
                  <div className="field">
                    <label htmlFor="f-company">Company</label>
                    <input type="text" id="f-company" placeholder="Your business name" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="field">
                    <label htmlFor="f-email">Email *</label>
                    <input type="email" id="f-email" required placeholder="you@company.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                  </div>
                  <div className="field">
                    <label htmlFor="f-phone">Phone</label>
                    <input type="tel" id="f-phone" placeholder="(555) 555-5555" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="f-services">What services are you interested in?</label>
                  <select id="f-services" value={form.services} onChange={(e) => setForm({ ...form, services: e.target.value })}>
                    <option value="">Select a service...</option>
                    <option>Financial Reporting &amp; Analysis</option>
                    <option>Accounts Payable</option>
                    <option>Accounts Receivable &amp; Collections</option>
                    <option>Invoicing &amp; Billing</option>
                    <option>Payroll Processing</option>
                    <option>Accounting Process Optimization</option>
                    <option>Bookkeeping &amp; Financial Organization</option>
                    <option>Multiple services / Not sure yet</option>
                  </select>
                </div>
                <div className="field">
                  <label htmlFor="f-message">Message *</label>
                  <textarea id="f-message" required placeholder="Tell me about your business and what you'd like help with..." value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
                </div>
                <button type="submit" className="btn form-submit">Send Message
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" /></svg>
                </button>
                {status.msg && <div className={`form-status ${status.type}`}>{status.msg}</div>}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="container footer-inner">
          <div className="footer-brand">
            <img src="/brand/radi-financial-logo.png" alt="Radi Financial LLC" className="footer-logo" />
          </div>
          <ul className="footer-links">
            <li><a href="#about">About</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
          <div className="footer-copy">© {new Date().getFullYear()} Radi Financial LLC · Accounting &amp; Financial Operations · Boca Raton, FL</div>
        </div>
      </footer>

      <ChatWidget />
    </div>
  );
}
